<template>
  <div class="horizontal-padding">
    <h1>Events</h1>

    <p class="text-center">
      This feature is coming soon.
    </p>
  </div>
</template>
